import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/billing/invoices/layout.tsx")